// Model
import { Model } from "@mgs/ci2019-common/src/models/model/Model";
import { TypeSelectionResultDTO } from "./TypeSelectionResultDTO";
import { SelectField } from "./SelectField";

export class TypeSelectionResult extends Model<TypeSelectionResultDTO> {
  public klasse!: number;
  public selects!: SelectField[];
  public dates?: { min: string; max: string };

  constructor(initial?: Partial<TypeSelectionResultDTO>) {
    super();
    this.init(initial);
  }
}
